// Logo asset exports for IntelligentHive branding
import intelligentHiveLogo from './primaryLogo.svg';
import intelligentHiveLogoDark from './white.svg';
import intelligentHiveIcon from './whiteWordmark.svg';

export {
  intelligentHiveLogo,
  intelligentHiveLogoDark,
  intelligentHiveIcon
};

// Logo configuration for different use cases
export const logoConfig = {
  main: intelligentHiveLogo,
  dark: intelligentHiveLogoDark,
  icon: intelligentHiveIcon,
  alt: 'IntelligentHive'
};
